import React from "react";
import PropTypes from "prop-types";

export default function SearchBar({ query = "", handleInputChange }) {
  return (
    <div className="search-bar-wrap">
      <label className="sr-only" htmlFor="search-input">
        Rechercher un produit
      </label>
      <input
        className="search-bar"
        type="search"
        name="query"
        value={query}
        id="search-input"
        placeholder="Référence, Gencod ou SKU client…"
        onChange={handleInputChange}
        autoComplete="off"
      />
    </div>
  );
}

SearchBar.propTypes = {
  query: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
};
